import React from 'react';
import Isvg from 'react-inlinesvg';
import _ from 'lodash';
import { parseAmount, friendlyDate } from 'app/utils/parsers';
import history from 'app/routes/history';
import ReactToPrint from 'react-to-print';
import base64 from 'base-64';

import Button from 'app/components/general/Button';
import SectionGroup from 'app/components/general/SectionGroup';
import { CardBody, Card, Progress } from 'reactstrap';
import PaymentCardMin from 'app/components/matches/PaymentCardMin';
import SuccessIcon from 'app/images/icons/success.svg';

import ReceiptPrintComponent from './ReceiptPrintComponent';

interface IReceiptComponentProps {
  matchCardData: {
    round: string;
    dateTime: string;
    eventInfo: string;
    amount: string;
    section: string;
    time: string;
    location: string;
    status: string;
    otherTeamStatus: string;
    statuses: [
      {
        colour: string;
        text: string;
      }
    ];
  };
  status: string;
  receiptType: string;
  reference: string;
  contextReference: string;
  paidAt: string;
  paymentAmount: string;
  paymentType: string;
  paymentMethod: string;
  section: string;
  description: string;
  paymentReference: string;
  bulkMatchPayment: any;
  from: string;
  totalAmountPaid: number;
  lineItems: { amount: number; description: string }[];
}

export default class ReceiptComponent extends React.Component<
  IReceiptComponentProps,
  {}
> {
  static defaultProps: IReceiptComponentProps = {
    matchCardData: {
      round: undefined,
      dateTime: undefined,
      eventInfo: undefined,
      amount: undefined,
      section: undefined,
      time: undefined,
      location: undefined,
      statuses: undefined,
      status: undefined,
      otherTeamStatus: undefined,
    },
    status: undefined,
    teamName: undefined,
    paidAt: undefined,
    section: undefined,
    description: undefined,
    paymentAmount: undefined,
    paymentMethod: undefined,
    paymentReference: undefined,
    from: undefined,
    totalAmountPaid: undefined,
    lineItems: [],
  };

  handleDownload = () => { };

  handleCollect = (e) => {
    e.preventDefault();
    if (this.props.receiptType == 'forfeit') {
      const payRequestPreconfigData = base64.encode(JSON.stringify({
        category: {
          id: 'forfeit',
          name: 'Forfeit fees',
        },
        description: `${this.props.matchCardData.round} - Forfeit`,
        amount: parseAmount(this.props.totalAmountPaid),
        dueDate: this.props.fixtureMatch.eventAt,
        forfeitId: this.props.forfeit?.id,
        paymentEventId: this.props.fixtureMatch.id,
        groupId: this.props.group.id,
      }))
      history.push(`/payment-requests/new:${payRequestPreconfigData}`)
    } else {
      const payRequestPreconfigData = base64.encode(JSON.stringify({
        description: `${this.props.matchCardData.round}`,
        amount: parseAmount(this.props.totalAmountPaid),
        dueDate: this.props.fixtureMatch.eventAt,
        matchPaymentId: this.props.matchPayment?.id,
        paymentEventId: this.props.fixtureMatch.id,
        groupId: this.props.group.id,
      }))
      history.push(`/payment-requests/new:${payRequestPreconfigData}`)
    }
  };

  renderLineItems = () => _.map(this.props.lineItems, (lineItem) => (
    <div className="row" key={lineItem.description}>
      <div className="col col-8 text-dark-grey">
        {lineItem.description}
      </div>
      <div className="col col-4 text-right text-dark-grey">
        {parseAmount(lineItem.amount)}
      </div>
    </div>
  ));

  renderForfeitInfo = () => (
    <div className="row with-margin-top">
      <div className="col">
        <SectionGroup>
          <div className="row">
            <div className="col">
              <span className="form-content">
                <p>
                  The forfeit has been confirmed. The opposition team will be
                  notified of the cancellation via SMS and email. Your receipt
                  is below.
                </p>
                <p className="with-no-margin-bottom">
                  If you would like your team members to pay you back, you can
                  use Teammo to collect the money.
                </p>
              </span>
            </div>
          </div>
        </SectionGroup>
      </div>
    </div>
  );

  render(): React.ReactNode {
    const progressPercentage = this.props.teamPaymentRequest?.collected === 0
      ? 0
      : (this.props.teamPaymentRequest?.collected / this.props.teamPaymentRequest?.total) * 100;

    return (
      <div>
        {/* {this.props.matchCardData?.eventInfo !== undefined && this.props.bulkMatchPayment?.id === undefined && (
          <div className="row">
            <div className="col">
              <PaymentCardMin {...this.props.matchCardData} truncatedButtons />
            </div>
          </div>
        )} */}
        {(this.props.receiptType === 'forfeit' || this.props.receiptType === 'forfeit-covid') && this.renderForfeitInfo()}
        <div className="row with-margin-top">
          <div className="col">
            <Card>
              <CardBody className="with-extra-padding">
                <div className="row">
                  <div className="col">
                    <h3 className="text-black">
                      Receipt from
                      {' '}
                      {this.props.from}
                    </h3>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="divider full" />
                  </div>
                </div>
                <div className="row">
                  <div className="col col-4 caption-text text-grey">
                    Payment Status
                  </div>
                  <div className="col text-right capitalize normal-text">
                    <Isvg className="with-margin-right receipt-success" src={SuccessIcon} />
                    {this.props.status}
                  </div>
                </div>
                <div className="row with-margin-top">
                  <div className="col col-4 caption-text text-grey">
                    Receipt Reference
                  </div>
                  <div className="col text-right normal-text">
                    {this.props.reference}
                  </div>
                </div>
                {!_.isEmpty(this.props.contextReference) && (<div className="row with-margin-top">
                  <div className="col col-4 caption-text text-grey">
                    Match Reference
                  </div>
                  <div className="col text-right normal-text">
                    {this.props.contextReference}
                  </div>
                </div>)}
                <div className="row with-margin-top">
                  <div className="col col-4 caption-text text-grey">
                    Date Paid
                  </div>
                  <div className="col text-right normal-text">
                    {friendlyDate(this.props.paidAt)}
                  </div>
                </div>
                <div className="row with-margin-top">
                  <div className="col col-4 caption-text text-grey">
                    Payment Method
                  </div>
                  <div className="col text-right normal-text">
                    {this.props.paymentMethod}
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="divider full" />
                  </div>
                </div>
                <div className="row with-margin-bottom">
                  <div className="col text-black text-weight-medium">
                    Summary
                  </div>
                </div>
                {this.renderLineItems()}
                <div className="row">
                  <div className="col">
                    <div className="divider full" />
                  </div>
                </div>
                <div className="row">
                  <div className="col text-black text-weight-medium">
                    Amount Paid
                  </div>
                  <div className="col text-right text-dark-grey text-weight-medium">
                    {parseAmount(this.props.totalAmountPaid)}
                  </div>
                </div>
                <div className="row">
                  <div className="col" />
                </div>
                <div className="row">
                  <div className="col">
                    <div className="divider full" />
                  </div>
                </div>
                <div className="row">
                  <div className="col normal-text text-grey">
                    If you have any questions, please visit our
                    {' '}
                    <a
                      href="https://help.teammo.com.au"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      help centre
                    </a>
                    .
                  </div>
                </div>
                <div className="row with-margin-top d-none d-sm-flex">
                  <div className="col">
                    <ReactToPrint
                      trigger={() => (
                        <Button
                          className="btn-2"
                          type="submit"
                        >
                          Download receipt
                        </Button>
                      )}
                      content={() => this.componentRef}
                    />
                    <div className="d-none">
                      <ReceiptPrintComponent
                        {...this.props}
                        ref={(el) => (this.componentRef = el)}
                      />
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    );
  }
}
